/* ════════════ DRIFTING CODE TOKENS ════════════
   The langs page's atmosphere: keywords from the five contenders
   drifting up the screen in their tier colors, like a compile log
   rising out of the void. */

import { fillBars } from "./statbars";
import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function glyphs(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#glyphs")!;
  const ctx = c.getContext("2d")!;

  // token pools per language, weighted toward the top of the list
  const pools: Array<{ col: string; tokens: string[] }> = [
    { col: "#00ffa3", tokens: ["proc", "defer", "::", "#soa", "bit_set", "context", "distinct"] },
    { col: "#ff7a3c", tokens: ["fn", "match", "Option<T>", "&mut", "impl", "Result"] },
    { col: "#6f8fff", tokens: ["constexpr", "template<>", "auto&&", "~dtor()", "std::"] },
    { col: "#2bd9ff", tokens: ["=>", "satisfies", "unknown", "as const"] },
    { col: "#ffd43b", tokens: ["def", "self", "__init__", "import this"] },
  ];
  // S tier drifts by twice as often as F tier
  const weights = [5, 4, 3, 2, 1];

  type Tok = { x: number; y: number; vy: number; text: string; col: string; size: number; alpha: number };
  let toks: Tok[] = [];

  const pick = (): { col: string; text: string } => {
    const total = weights.reduce((a, b) => a + b, 0);
    let r = Math.random() * total;
    for (let i = 0; i < pools.length; i++) {
      r -= weights[i]!;
      if (r <= 0) {
        const p = pools[i]!;
        return { col: p.col, text: p.tokens[(Math.random() * p.tokens.length) | 0]! };
      }
    }
    return { col: pools[0]!.col, text: pools[0]!.tokens[0]! };
  };

  const make = (anywhere = false): Tok => {
    const { col, text } = pick();
    return {
      x: Math.random() * c.width,
      y: anywhere ? Math.random() * c.height : c.height + 16,
      vy: 0.15 + Math.random() * 0.35,
      text,
      col,
      size: Math.random() > 0.8 ? 13 : 11,
      alpha: 0.25 + Math.random() * 0.35,
    };
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(34, Math.floor((c.width * c.height) / 46000));
    toks = Array.from({ length: count }, () => make(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const t of toks) {
      ctx.globalAlpha = t.alpha;
      ctx.fillStyle = t.col;
      ctx.font = `${t.size}px "IBM Plex Mono", monospace`;
      ctx.fillText(t.text, t.x | 0, t.y | 0);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (const t of toks) {
      t.y -= t.vy;
      if (t.y < -16) Object.assign(t, make());
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage((signal) => {
  glyphs(signal);
  fillBars();
});
